const messages = {
  title: "Informazioni su BS Plus",
  description:
    "IL TUO <span class='text-danger'>PLUS</span> CON BRIDGESTONE - questo è il motivo conduttore dell'intero programma BRIDGESTONE <span class='text-danger'>PLUS</span><br/>per i nostri partner commerciali. Scoprite i numerosi vantaggi esclusivi.",
};

export default {
  messages,
};
